import { Company } from '@mews-commander/data-access';

const mock: Company[] = [
    {
        id: '8d2e2413-6e4d-426b-84a4-ae2400ad47c5',
        chainId: '890cffbc-383a-405f-bbb0-858a7b1c031e',
        name: 'Prague City Roller Derby',
        motherCompanyId: null,
        fiscalIdentifier: null,
        email: null,
        invoicingEmail: null,
        website: null,
        referenceId: null,
        externalIdentifier: null,
        telephone: null,
        accountingCode: null,
        taxIdentifier: null,
        additionalTaxIdentifier: null,
        billingCode: null,
        sourceId: null,
        creditRatingBasic: null,
        invoiceDueInterval: 'P0M30DT0H0M0S',
        iata: null,
        notes: null,
        number: 15774,
        contactPerson: null,
        contact: null,
        department: null,
        options: {
            isInvoiceable: true,
            addFeesToInvoices: false,
            addTaxDeductedPaymentToInvoices: false,
        },
        dunsNumber: null,
        classifications: {
            corporate: false,
            internal: false,
            private: false,
            onlineTravelAgency: false,
            globalDistributionSystem: false,
            marketing: false,
            inactive: false,
            governmentEntity: false,
        },
        createdUtc: '2022-01-21T10:30:53.644Z',
        updatedUtc: '2023-07-21T07:45:13.919Z',
        creatorProfileId: 'ba40834b-8854-4ac3-9a72-ae2200f9e9ea',
        updaterProfileId: 'ba40834b-8854-4ac3-9a72-ae2200f9e9ea',
    },
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useGetAllCompaniesQuery = (ids: string[]): Company[] => {
    // TODO: use this in follow up task when BE endpoint is ready
    // const { data } = useRepositoryQuery(
    //     'companies',
    //     'getAll',
    //     { ids },
    //     {
    //         enabled: !!ids.length,
    //         select: (result) => result.companies || [],
    //     }
    // );

    return mock;
};
